module.exports = __webpack_public_path__ + "img/xiaomi12timage2.8d536945.png";